import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDealBoard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 4,
		y: 4.5,
		width: 16,
		height: 6,
		stroke: "#636C7B",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 4,
		y: 13.5,
		width: 16,
		height: 6,
		stroke: "#636C7B",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})]
});
export default SvgDealBoard;
